import {Addchart} from '@mui/icons-material'

// ==============================|| DASHBOARD MENU ITEMS ||============================== //

const customerTasklistManagement = {
    id: 'customerTasklistManagement',
    // title: 'Dashboard',
    type: 'group',
    children: [
        {
            id: 'customerTasklistManagement',
            title: 'Customer Tasklist Management',
            type: 'item',
            url: '/customerTasklistManagement',
            icon: Addchart,
            breadcrumbs: false,
            
        },
       
    ]
};

export default customerTasklistManagement;
